var c = 0;
function createFilter(radius, duration, reverse) {
    if (!radius) {
        throw new Error("No radius specified");
    }
    if (!duration) {
        throw new Error("No duration specified");
    }
    var id = 'better-blur-' + (c++);
    var from = reverse ? radius : 0;
    var to = reverse ? 0 : radius;
    var filter = '<svg class="blur-filter">\
    <filter id="' + id + '" color-interpolation-filters="sRGB" x="0" y="0" width="1" height="1">\
        <feGaussianBlur id="' + id + '-filter" stdDeviation="' + from + '" result="blurred" />\
        <feColorMatrix type="matrix" values="1 0 0 0 0, 0 1 0 0 0, 0 0 1 0 0, 0 0 0 9 0"/>\
        <feComposite in2="SourceGraphic" operator="in">\
    </filter>\
    <animate id="' + id + '-animation" xlink:href="#' + id + '-filter" attributeName="stdDeviation" from="' + from + '" to="' + to + '" dur="#{duration}s" begin="indefinite"/>\
    <animate id="' + id + '-animation-reverse" xlink:href="#' + id + '-filter" attributeName="stdDeviation" from="' + to + '" to="' + from + '" dur="#{duration}s" begin="indefinite"/>\
    </svg>';
    var el = document.createElement('div');
    el.innerHTML = filter.replace(/#{radius}/g, radius).replace(/#{duration}/g, duration);
    document.body.appendChild(el.firstChild);
    return id;
}

function attach(el, mouseEnter = false) {
    var id = el.dataset.filterId;

    if (!id) {
        var radius = el.dataset.blurRadius || 50;
        var duration = el.dataset.blurDuration || 0.4;
        var reverse = el.dataset.blurReverse || false;
        var ratio = (window.innerWidth / 640);
        if (ratio > 1)
            ratio = 1;
        radius = parseInt(radius * (ratio));
        var id = createFilter(radius, duration, reverse);

        var filter = document.getElementById(id + '-filter');
        var animation = document.getElementById(id + '-animation');
        var animationReverse = document.getElementById(id + '-animation-reverse');

        animation.addEventListener('beginEvent', function () {
            filter.setAttribute("stdDeviation", reverse ? 0 : radius);
        });

        animationReverse.addEventListener('beginEvent', function () {
            filter.setAttribute("stdDeviation", reverse ? radius : 0)
        });

        el.addEventListener('mouseenter', function (e) {
            animationReverse.endElement();
            animation.beginElement();
        });

        el.addEventListener('mouseleave', function () {
            setTimeout(function () {
                animation.endElement();
                animationReverse.beginElement();
            }, 200);
        });

        el.dataset.filterId = id;
        el.style.filter = 'url(#' + id + ')';

        // triggering layout refresh on safari
        var ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1) {
            el.style.display = 'unset';
            el.offsetHeight; // this is required
        }

        el.style.display = 'block';

        // this is required for Firefox
        if (mouseEnter) {
            animationReverse.endElement();
            animation.beginElement();
        }
    }
    return id;
}

function init() {
    $(document).on('mouseenter', '.blur', function () {
        attach(this, true);
    });
    [...document.querySelectorAll('.blur')].forEach(el => attach(el));

    var timeout;
    document.addEventListener("DOMNodeInserted", function (event) {
        if (event.srcElement.nodeName !== 'svg') {
            clearTimeout(timeout);
            timeout = setTimeout(function () {
                timeout = null;
                [...document.querySelectorAll('.blur')].forEach(el => attach(el));
            }, 0); // debouncing node insertions
        }
    }, false);
}

module.exports = {
    init: init
};